import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { MedicalmapPageRoutingModule } from './medicalmap-routing.module';

import { MedicalmapPage } from './medicalmap.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    MedicalmapPageRoutingModule
  ],
  declarations: [MedicalmapPage]
})
export class MedicalmapPageModule {}
